// import { ACTIONS_TRIGGER_VALIDATION } from '../form-designer/constants/runtime.constants';
import { validateReport } from '../report-designer/actions/report-designer.actions';

export const VALIDATION_DELAY = process.env.NODE_ENV === 'test' ? 0 : 500;
const ACTIONS_TRIGGER_VALIDATION = [
  'UPDATE_CONTROL_PROPERTY',
  'UPDATE_CONTROL_PROPERTIES',
  'ADD_NEW_DISTRIBUTION_LIST_ROW',
  'ADD_NEW_DISTRIBUTION_LIST_ROWS',
];

let timer = undefined;

export const reportValidator = ({ dispatch }) => (next) => (action) => {
  const { type } = action;

  next(action);

  if (ACTIONS_TRIGGER_VALIDATION.includes(type)) {
    clearTimeout(timer);

    timer = setTimeout(() => {
      dispatch(validateReport());
    }, VALIDATION_DELAY);
  }
};
